// extracted by mini-css-extract-plugin
module.exports = {"date":"Date_date__uXOej","updatedDate":"Date_updatedDate__JQo_Q"};